import { cn } from '@/utils/cn';
import React, { useContext } from 'react';
import { DeviceFrameDensityContext, PreviewFluidContext } from './deviceFrameStyle';

interface DeviceFrameProps {
  children: React.ReactNode;
  className?: string;
  /**
   * 'card'  - clean rounded card with a soft shadow (feed-style posts)
   * 'phone' - slim device bezel, for full-screen vertical video only
   */
  variant?: 'card' | 'phone';
}

/**
 * Light CSS-only frame for previews. Feed posts sit on a plain card (no phone
 * shell); only vertical, full-screen formats get a slim bezel.
 */
export const DeviceFrame = ({ children, className, variant = 'card' }: DeviceFrameProps) => {
  const slim = useContext(DeviceFrameDensityContext) === 'slim';
  const fluid = useContext(PreviewFluidContext);
  if (variant === 'phone') {
    return (
      <div
        className={cn(
          'relative mx-auto w-full overflow-hidden rounded-[1.75rem] bg-black',
          fluid ? 'max-w-none' : 'max-w-[300px]',
          slim ? 'border-[3px] border-gray-900 shadow-sm' : 'border-[5px] border-gray-900 shadow-xl',
          className
        )}
      >
        <div className="absolute left-1/2 top-2 z-10 h-1.5 w-12 -translate-x-1/2 rounded-full bg-gray-800" />
        <div className={cn('overflow-hidden', slim ? 'rounded-[1.5rem]' : 'rounded-[1.4rem]')}>{children}</div>
      </div>
    );
  }
  return (
    <div
      className={cn(
        'relative mx-auto w-full overflow-hidden rounded-xl bg-white',
        fluid ? 'max-w-none' : 'max-w-[375px]',
        slim ? 'border border-gray-200 shadow-sm' : 'border border-gray-200 shadow-md',
        className
      )}
    >
      {children}
    </div>
  );
};
